export const TAGS_SEARCH_KEY = 'tagsLandingPageSearch';
